module.exports = __webpack_public_path__ + "img/WordPress_logo.9d69fe05.png";